import * as React from 'react';

function StatusIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 16 16' fill='none' {...props}>
			<path
				d='M6 8l1.333 1.333L10 6.666m-7.433-.92a2.667 2.667 0 013.186-3.18 2.667 2.667 0 014.494 0 2.667 2.667 0 013.186 3.187 2.667 2.667 0 010 4.494 2.667 2.667 0 01-3.18 3.186 2.666 2.666 0 01-4.5 0 2.666 2.666 0 01-3.186-3.18 2.667 2.667 0 010-4.506z'
				stroke='#545454'
				strokeWidth={1.33333}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default StatusIcon;
